import { type TransformerConfig } from '../common/types';
import { createEncodeToDbFn, createDecodeFromDbFn } from '../common/utils';
import {
  createNumericTransformer,
  createSha256Transformer,
  createTimestampTransformer,
} from '../common/sql';
import { AssetSchema, DBAssetSchema } from './schemas';

export const AssetCodecConfig: TransformerConfig<typeof AssetSchema, typeof DBAssetSchema> = {
  name: 'Asset',
  clientSchema: AssetSchema,
  dbSchema: DBAssetSchema,
  transformers: [
    createSha256Transformer<typeof AssetSchema, typeof DBAssetSchema>('sha256'),
    createNumericTransformer<typeof AssetSchema, typeof DBAssetSchema>('byteSize'),
    createTimestampTransformer<typeof AssetSchema, typeof DBAssetSchema>('createdAt'),
    createTimestampTransformer<typeof AssetSchema, typeof DBAssetSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const encodeAssetToDb = createEncodeToDbFn(AssetCodecConfig);
export const decodeAssetFromDb = createDecodeFromDbFn(AssetCodecConfig);
